/*
 * transfer util 穿梭框公共方法
 * author zhousheng
 */
var DEFAULT_BOX_HEIGHT = 264;
var HEADER_HEIGHT = 40;
var DOUBLE_BORDER_WIDTH = 2;
var SEARCH_HEIGHT = 40;
export var ITEM_HEIGHT = 32;
var heightReg = /^\d+/;
export var getBodyHeight = function getBodyHeight(styleObj, showSearch) {
  var _a;
  var bodyHeight = DEFAULT_BOX_HEIGHT - HEADER_HEIGHT - DOUBLE_BORDER_WIDTH;
  var height = styleObj.height;
  if (height === undefined || !heightReg.test(height)) {
    bodyHeight = showSearch ? bodyHeight - SEARCH_HEIGHT : bodyHeight;
  } else {
    var heightNum = Number((_a = heightReg.exec(height)) === null || _a === void 0 ? void 0 : _a[0]);
    bodyHeight = showSearch ? heightNum - HEADER_HEIGHT - DOUBLE_BORDER_WIDTH - SEARCH_HEIGHT : heightNum - HEADER_HEIGHT - DOUBLE_BORDER_WIDTH;
  }
  return bodyHeight;
};